import type { RouteObject } from 'react-router';

import { gatewaysRoute } from './gateways/gateways.route';
import { plansRoute } from './plans/plans.route';
import { reportingRoute } from './reporting/reporting.route';

/**
 * The three subscription surfaces, aggregated so the composition root takes one
 * import line rather than three.
 *
 * The file is `.routes.tsx` **plural** because it exports an array — the name
 * alone tells the router what shape to expect at import time.
 *
 * **The bucket is file organisation and never a URL segment.** «الاشتراك» is a
 * group caption in the navigation column, not a route, so no address carries a
 * `subscription` segment and no breadcrumb states one. The three paths are the
 * ones the sitemap fixes: `/plans`, `/subscriptions`, `/payment-gateways`.
 */
export const subscriptionRoutes: RouteObject[] = [plansRoute, reportingRoute, gatewaysRoute];
